import { Injectable } from '@angular/core';
import { ToastComponent, ToastModel } from '@syncfusion/ej2-angular-notifications';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toast: ToastComponent | null = null;
  private timeout: number = 8000;

  public toasts: { [key: string]: Object }[] = [
    { title: 'Warning!', content: 'There was a problem with your network connection.', cssClass: 'e-toast-warning', icon: 'toast-icons fas fa-exclamation-triangle' },
    { title: 'Success!', content: 'Your message has been sent successfully.', cssClass: 'e-toast-success', icon: 'toast-icons fas fa-check-circle' },
    { title: 'Error', content: 'A problem has been occurred while submitting your data.', cssClass: 'e-toast-danger', icon: 'toast-icons fas fa-exclamation-triangle' },
    { title: 'Information!', content: 'Please read the comments carefully.', cssClass: 'e-toast-info', icon: 'fas fa-info-circle toast-icons' },
    { title: 'No Permissions!', content: 'There was a problem.', cssClass: 'e-toast-warning', icon: 'toast-icons fad fa-lock' },

];

  setToast(toast: ToastComponent) {
    this.toast = toast;
  }

  constructor() { }

  public showAuthRefreshError(content: string = '', title: string = 'Ops, ocorreu um problema!') {
    let toastModel: ToastModel = this.toasts[2];

    toastModel.title = title;
    toastModel.content = content;
    toastModel.timeOut = this.timeout;
    
    this.showAuthToast(toastModel);
  }

  public showWarning(content: string = '', title: string = 'Ops, ocorreu um problema!') {
    let toastModel: ToastModel = this.toasts[0];

    toastModel.title = title;
    toastModel.content = content;
    toastModel.timeOut = this.timeout;

    this.showToast(toastModel);
  }

  public showError(content: string = '', title: string = 'Ops, ocorreu um problema!') {
    let toastModel: ToastModel = this.toasts[2];

    toastModel.title = title;
    toastModel.content = content;
    toastModel.timeOut = this.timeout;

    this.showToast(toastModel);
  }

  public showInfo(content: string = '', title: string = 'Atenção!') {
    let toastModel: ToastModel = this.toasts[3];

    toastModel.title = title;
    toastModel.content = content;
    toastModel.timeOut = this.timeout;

    this.showToast(toastModel);
  }

  public showSuccess(content: string = '', title: string = 'Sucesso!') {
    let toastModel: ToastModel = this.toasts[1];

    toastModel.title = title;
    toastModel.content = content;
    toastModel.timeOut = this.timeout;

    this.showToast(toastModel);
  }

  private showToast(toastModel: ToastModel) {
    let delay: number = 0;

    if(this.toast === null) {
      delay = 500;
    }

    if(this.toast && delay === 0) {
      this.toast.show(toastModel);
    } else {
      setTimeout(() => {
        this.showToast(toastModel);
      }, delay);
    }
  }

  public showNoPermission(content: string = 'Desculpe, sem permissão para acessar este recurso', title: string = 'Sem Permissão!') {
    let toastModel: ToastModel = this.toasts[4];

    toastModel.title = title;
    toastModel.content = content;
    toastModel.timeOut = this.timeout;

    this.showToast(toastModel);
  }

  private showAuthToast(toastModel: ToastModel) {
    let delay: number = 0;

    if(this.toast === null)
      delay = 500;

    if(this.toast && delay === 0) {
      this.toast.hide('All');
      this.toast.show(toastModel);
    } else {
      setTimeout(() => {
        this.showToast(toastModel);
      }, delay);
    }
  }
}
